import { createElement } from 'react';
import { Button, ButtonVariant } from '../../Button';
import {
  Undo,
  ArrowRightAddDualSelector as Add,
  ArrowRightAddAllDualSelector as AddAll,
  ArrowLeftRemoveDualSelector as Remove,
  ArrowLeftRemoveAllDualSelector as RemoveAll,
} from '@sas/react-svg';
import { createUseTextLocalizer } from '../../../locale/createUseTextLocalizer';
import bundle from '../NovaComponents-DualSelector-gui-icu.properties';
import { renderInlineCssVars, useDesignTokens } from '../../../theme';
import { postfixTestId, TestIdProps } from '../../../util/testId';
import cx from 'classnames';
import './MoveButton.css';
import cn from './MoveButton.css.json';
export type ButtonDirection = 'add' | 'remove' | 'undo' | 'custom_add';
const useTextLocalizer = createUseTextLocalizer(bundle);

export interface MoveButtonProps extends TestIdProps {
  direction: ButtonDirection;
  isMoveAll: boolean;
  onPress: (direction: ButtonDirection, isMoveAll: boolean) => void;
  disabled: boolean;
  ariaLabel: string;
  customAddButtonTooltip?: string;
}

export const MoveButton = (props: MoveButtonProps) => {
  const dt = useDesignTokens();
  const moveButtonTokens = renderInlineCssVars(
    {
      spacing: dt.spacing.core.s,
    },
    'move-button'
  );

  const localize = useTextLocalizer();
  let selectActionText, selectionIcon: any;
  const icon: any = {
    add: Add,
    addAll: AddAll,
    undo: Undo,
    remove: Remove,
    removeAll: RemoveAll,
    custom_add: Add,
  };
  const { direction, isMoveAll } = props;
  let testIdText: string;

  /* -------------------------------------------
   * Icon & text selection for tooltip
   * ---------------------------------------------*/

  if (props.isMoveAll) {
    const newDirection = `${props.direction}All`;
    selectionIcon = icon[newDirection];
    selectActionText = localize(
      `moveButton.${newDirection.toLocaleLowerCase()}.button.tooltip.label`
    );
    testIdText = `${props.direction}All`;
  } else {
    selectionIcon = icon[props.direction];
    selectActionText = localize(`moveButton.${props.direction}.button.tooltip.label`);
    if (props.direction === 'custom_add' && props.customAddButtonTooltip) {
      selectActionText = props.customAddButtonTooltip;
    }
    testIdText = props.direction;
  }

  const classes =
    props.direction === 'custom_add' ? cx(cn.moveButtons, cn.customButton) : cn.moveButtons;
  return (
    <div className={classes} style={moveButtonTokens}>
      <Button
        testId={postfixTestId(props.testId, testIdText)}
        variant={ButtonVariant.Icon}
        icon={{ icon: selectionIcon, tooltip: selectActionText }}
        onPress={() => props.onPress(direction, isMoveAll)}
        disabled={props.disabled}
        ariaLabel={props.ariaLabel}
      />
    </div>
  );
};
